import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'agencySelect',
    'providedAgencyInput',
    'submitButton',
    'agencyInput',
  ];

  connect() {
    this.updateUI();
  }

  updateUI() {
    const isOtherSelected = this.agencySelectTarget.value === 'other';
    const isPlaceholderSelected = this.agencySelectTarget.value === '--';

    this.providedAgencyInputTarget.style.display = isOtherSelected
      ? 'block'
      : 'none';

    this.submitButtonTarget.disabled =
      isPlaceholderSelected ||
      (isOtherSelected && !this.agencyInputTarget.value.trim());
  }

  validateForm(event) {
    if (
      this.agencySelectTarget.value === 'other' &&
      !this.agencyInputTarget.value.trim()
    ) {
      event.preventDefault();
    }
  }
}
